export const TRANSLATIONS_FR = {
    price: "40€",
    addressname: "Salon des arts Mairie 29660 CARANTEC",
    emailname: "salonpeinturecarantec29@orange.fr",
    
    //links:
    linkhome:"Accueil",
    linkapply:"Candidatures",
    linkcontact:"Contacts",
    linkregisterform:"Remplir le formulaire en ligne",
    linkregisterdownload:"Formulaire",

    //footer:
    address:"Adresse : ",
    phone:"Téléphone : ",
    email:"Couriel : ",
    followus:"Suivez nous",

    //home page:
    expo:"Le Salon d'été 2026",
    honnorexpo:"",
    expodate: "du 12/07/26 au 16/08/26",
    expoplace: "Espace André JACQ",
    registrationlimitdate: " ouvertes 15/04/26",
    register:"Inscrivez Vous! ",
    partnership:"Devenez un partenaire  ",
    contactus:"Contactez nous!",
    location:"Lieu",
    beforethe:"",
    presentation1:"Le Salon des Arts de Carantec est une association régie par la loi 1901.",
    presentation2:"Fondée en 2011, cette association a pour but l’organisation de Salons de Peinture et Sculpture.",
    presentation3:"Ces expositions sont ouvertes à tout artiste ayant un numéro de SIRET sur candidature.",
    presentation4:"Pendant les expositions les artistes ont la possibilité d’animer des ", 
    workshop:" ateliers",
    presentation5:" pour partager leurs techniques et leur univers avec le public.",
    presentation5b:"Un ",
    discovery:"parcours découverte",
    presentation6:" est proposé aux enfants.",
    presentation7:"Si vous voulez plus d'informations, voir les affiches et les photos des expositions passées.",
    
    //apply page:
    registertitle:"Pour envoyer votre candidature ",
    registerprice:"tarif ",
    registerrules:"les règles pour vous inscrire ",
    createpdf:"Créer le pdf",
    painting:" peinture",
    sculpture:" sculpture",

    step2b:"Envoyer des photos de vos oeuvres par ",
    step2c:"Nouveaux inscrits: un texte sur votre parcours",
    step3:"Attendre la réponse des organisateurs ",
    step2a:"Si la réponse est positive, remplir le formulaire, le sauvegarder et l'envoyer par courrier avec un chèque de ",

    warning:"Vous pouvez rencontrer des difficultés en utilisant des mobiles",

    organisation:"Organisation",
    openning:"Ouverture au public : ",
    openningdate:" Dimanche 12 juillet 2026 à 15h.",
    openninghours:"Horaires d'ouverture : 15h à 19h30.",
    closure:"Fin le :",
    closuredate:" Dimanche 16 Août 2026.",
    privateviewtext:" Vernissage le :",
    privateview:" Samedi 11 juillet 2026 à 18h.",
    
    artworkdeposit:"Dépôt des œuvres",
    paintors:"Peintres :",
    sculptors:"Sculptures :",
    datepaintors:" Lundi 6 Juillet 2026  de 10h à 12h et de 14h à 16h.",
    datesculptors:" Mercredi 8 Juillet 2026 de 10h à 12h.",
    depositdatepaintors:" ",
    depositdatesculptors:" ",
    deposittext:"Accrochage et installation réalisés par l’association.",

    artworkretrival:"Retrait des œuvres",
    retrivaldate:" Dimanche 16 Août 2026 à 18h30 ou Lundi 17 Août de 10h à 12h.",
    retrivaltext:" ",

    artworkinfos:"Infos œuvres",
    infostext:"Les œuvres doivent être originales et ne pas avoir été déjà exposées dans notre salon. Dans un souci d’harmonie, les organisateurs se réservent le droit de limiter les œuvres exposées. Nous avons besoin de vos photos (avec une bonne définition) pour le choix de l’affiche.",
    infospaintors:" Chaque artiste dispose d’une surface de 1m20x1m80 (panneau horizontal ou vertical).",
    infossculptors:" 4 ou 5 oeuvres originales. Prévoir des socles blancs de préférence.",

    applicationlign1:"Le droit d’inscription est de ",
    applicationlign2:" à régler par chèque, après réception de la fiche de candidature et acceptation par l'association, à l’ordre de l’association Salon des Arts.",
    applicationaddress:"A l’adresse suivante : ",
    applicationrule1:"L’inscription au salon implique obligatoirement l’adhésion totale au présent règlement.",
    applicationrule2:"L’inscription n’est effective qu'après la réception du dossier complet et la confirmation de l'association.",

    salestext:"Le prix de vente de chaque œuvre est de la responsabilité de l’artiste. Chaque œuvre devra porter au dos : nom, prénom, adresse, le titre de l’œuvre et son prix ainsi qu’un certificat d’authenticité signé par l’artiste. ",
    salestext2:" Chaque œuvre devra être munie d’un système d’accrochage solide et pratique.",
    salestext3:" L’association demandera 10% sur les ventes.",

    insurancestext:"Les organisateurs prendront le plus grand soin de vos œuvres. La municipalité et l’association organisatrice de l’exposition ne répondent en aucun cas des dommages qui pourraient survenir aux œuvres pendant la durée de l’exposition. Les artistes sont invités à assurer leurs œuvres contre tout risque. Ils renoncent expressément à tout recours contre l’association. Le transport des œuvres aller et retour est à la charge de l’artiste.",

    permanancytext:"Les artistes sont invités à assurer une ou 2 permanences selon leurs disponibilités. La présence des artistes est un plus pour les échanges avec les visiteurs et favorise les ventes. Les ateliers de démonstrations sont à nouveau mis en place. Contactez nous si vous êtes intéressés. Penser à mettre des cartes de visite à disposition.",

    otherstext:"Il a été convenu que les seules ventes à l’accueil du salon, seraient les ventes des cartes, affiches, marque-pages appartenant à l’association.",

    //sidebar:
    regulation:"Règlement",
    info:"Infos",
    artwork:"Oeuvres",
    applications:"Candidatures",
    sales:"Ventes",
    insurances:"Assurances",
    permanency:"Permanences",
    others:"Divers",

    //contacts page:
    contacttitle:"Pour nous contacter",

    //notfound page:
    notfound:"Nous n'avons pas trouver la page, veuillez revenir à l'acceuil",
};